import React from 'react';
import {
  INDICES_TAB_VALUES,
  type IndicesTabValue,
} from '@constants/indicesTabs';
import {
  INDICES_PERIODS,
  type IndicesPeriod,
} from '@app-types/indices';
import './MarketHeader.less';

interface MarketHeaderProps {
  activeTab: IndicesTabValue;
  onSelectTab: (tab: IndicesTabValue) => void;
  activePeriod: IndicesPeriod;
  onSelectPeriod: (period: IndicesPeriod) => void;
}

const PRIMARY_TABS: ReadonlyArray<{ label: string; value: IndicesTabValue }> = [
  { label: '海外主要指標', value: INDICES_TAB_VALUES.global },
  { label: 'アジア株指数', value: INDICES_TAB_VALUES.asia },
];

const PERIOD_TABS: ReadonlyArray<{ label: string; value: IndicesPeriod }> = [
  { label: '日足', value: INDICES_PERIODS.daily },
  { label: '週足', value: INDICES_PERIODS.weekly },
  { label: '月足', value: INDICES_PERIODS.monthly },
];

const MarketHeader: React.FC<MarketHeaderProps> = ({
  activeTab,
  onSelectTab,
  activePeriod,
  onSelectPeriod,
}) => (
  <header className="market-header" data-node-id="3838:1420">
    <h1 className="market-header__title" data-node-id="3813:34017">マーケット情報</h1>
    <div className="market-header__primary-tabs" aria-label="マーケット区分">
      {PRIMARY_TABS.map((tab) => {
        const isActive = tab.value === activeTab;

        return (
          <button
            key={tab.value}
            type="button"
            className={`market-header__tab${isActive ? ' market-header__tab--active' : ''}`}
            aria-label={tab.label}
            aria-pressed={isActive}
            onClick={() => onSelectTab(tab.value)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
    <div className="market-header__period-tabs" role="group" aria-label="表示期間">
      {PERIOD_TABS.map((period) => {
        const isActive = period.value === activePeriod;

        return (
          <button
            key={period.value}
            type="button"
            className={`market-header__period-tab${isActive ? ' market-header__period-tab--active' : ''}`}
            aria-label={period.label}
            aria-pressed={isActive}
            onClick={() => onSelectPeriod(period.value)}
          >
            {period.label}
          </button>
        );
      })}
    </div>
  </header>
);

export default MarketHeader;
